import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { StripeService } from "../../services/stripe.service";

@Component({
  selector: "common-payment-element",
  templateUrl: "./payment-element.component.html",
  styleUrls: ["./payment-element.component.scss"],
})
export class PaymentElementComponent implements OnInit {
  @Input() showButton: boolean;
  @Input() paymentCompletionPage: string;
  @Output() errorMessage = new EventEmitter<string>();

  elements: any;
  stripe: any;
  constructor(private stripeService: StripeService) {}

  async ngOnInit(): Promise<void> {
    this.stripe = await this.stripeService.init();
    const appearance = {
      /* appearance */
    };
    const options = {
      /* options */
      mode: "setup",
    };
    this.stripeService.setupIntent().subscribe((intent: any) => {
      this.elements = this.stripe.elements({ clientSecret: intent.client_secret, appearance });
      const paymentElement = this.elements.create("payment", options);
      paymentElement.mount("#payment-element");

      this.elements.fetchUpdates().then(result => {});
    });
  }

  submit(event?, paymentCompletionPage: string = this.paymentCompletionPage) {
    event?.preventDefault();
    this.stripe
      .confirmSetup({
        elements: this.elements,
        confirmParams: {
          // Make sure to change this to your payment completion page
          return_url: `${window.location.origin}${paymentCompletionPage}`,
        },
      })
      .then(result => {
        if (result.error.type === "card_error" || result.error.type === "validation_error") {
          this.errorMessage.emit(result.error.message);
        } else {
        }
      });

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    //   if (error.type === "card_error" || error.type === "validation_error") {
    //     alert(error.message);
    //   } else {
    //     alert(error.message);
    //   }
  }
}
